import { lazy } from "react";

const UiaIconAR = lazy(() => import("./uiaIconAR/UiaIconAR"));
const UiaIconArrowLink = lazy(() => import("./uiaIconArrowLink/UiaIconArrowLink"));
const UiaIconChevron = lazy(() => import("./uiaIconChevron/UiaIconChevron"));
const UiaIconClose = lazy(() => import("./uiaIconClose/UiaIconClose"));
const UiaIconLink = lazy(() => import("./uiaIconLink/UiaIconLink"));

export { UiaIconAR, UiaIconArrowLink, UiaIconChevron, UiaIconClose, UiaIconLink };
